import styled from 'styled-components';
import Constants from '../../Config/Constants';
import Assets from '../../Assets';

export const MemberCardBoxWrap = styled.div`
  .box {
    margin-bottom: 24px;
    border-radius: 3px;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    background: ${Constants.COLORS.WHITE};
    hr {
      background-color: ${Constants.COLORS.LIGHT_GREY};
      height: 1px;
      border: none;
    }
    .request {
      color: ${Constants.COLORS.DARK_BLUE};
      cursor: pointer;
    }
  }
  .component_no_member {
    text-align: center;
    font-weight: bold;
    text-transform: capitalize;
    padding: 30px 0;
  }
`;

export const DescriptionWrap = styled.div`
  background: ${Assets.COLOR_PALLETE.white};
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  padding: 3% 4.3%;
  font-size: 12px;
  line-height: 1.67;
  font-weight: 600;
`;
